export default function SafetyHarborMistakesSection() {
  const mistakes = [
    {
      icon: "ri-error-warning-line",
      title: "Waiting Until the Last Minute",
      desc: "Standard passport processing takes 7–11 weeks. Even expedited mail-in service takes 3–5 weeks. Safety Harbor travelers who discover passport issues days before a TPA flight or Tampa Bay cruise have no option but emergency courier service — which costs more and adds stress.",
      fix: "Check your passport expiration when you book travel, not when you pack. Set a calendar reminder 8 months before expiration.",
    },
    {
      icon: "ri-image-line",
      title: "Using the Wrong Passport Photo",
      desc: "The #1 reason applications are rejected. Common mistakes: smiling, glasses, shadows, wrong background color, incorrect size (must be 2×2 inches), or photos printed on the wrong paper. Many Safety Harbor travelers use CVS, Walgreens, or UPS store photo services, but not all locations are familiar with current State Department photo requirements.",
      fix: "Use a professional passport photo service or our photo review checklist. We verify your photo meets every State Department requirement before submission.",
    },
    {
      icon: "ri-file-damage-line",
      title: "Submitting Incomplete or Incorrect Forms",
      desc: "The DS-11, DS-82, and DS-64 forms have strict requirements. Common errors include: wrong form for your situation, missing signatures, incorrect date format, blank required fields, and using outdated form versions. A single error can delay your application by weeks.",
      fix: "Our document review team checks every form field before submission. We catch errors that would cause rejection and guide you through corrections.",
    },
    {
      icon: "ri-parent-line",
      title: "Forgetting Parental Consent for Minors",
      desc: "Child passport applications (under 16) require both parents' consent. Common mistakes: one parent missing from the appointment, absent parent's notarized consent form missing, or incorrect parental identification. This is the #1 cause of child passport delays for Safety Harbor families.",
      fix: "We provide a detailed parental consent checklist for every child passport application. Our team reviews all documents before your acceptance facility visit.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "Booking Travel Without Checking the 6-Month Rule",
      desc: "Many countries require your passport to be valid for 6 months beyond your travel dates. A passport expiring 4 months after your return date may be rejected at check-in or immigration. This affects Safety Harbor travelers to Mexico, the Caribbean, Europe, and most of Asia.",
      fix: "Verify the entry requirements for every country on your itinerary. When in doubt, renew if your passport expires within 9 months of your return date.",
    },
    {
      icon: "ri-water-flash-line",
      title: "Submitting a Damaged Passport",
      desc: "Water damage from Tampa Bay boating trips, frayed edges, torn pages, or faded covers can render a passport invalid. Many Safety Harbor residents discover passport damage only when they pull it out for a trip — after months of storage in humid Florida conditions.",
      fix: "Inspect your passport annually for damage. If you see water stains, torn pages, or cover wear, replace it proactively before travel planning begins.",
    },
  ];

  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Avoid Delays</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Common Passport Mistakes Safety Harbor Travelers Make
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the most frequent errors we see from Pinellas County applicants. Avoiding them saves weeks of processing time and hundreds of dollars in emergency fees.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((m, i) => (
            <div
              key={i}
              className="bg-white rounded-lg border border-gray-200 p-6 hover:border-red-300 transition-all duration-200 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 flex-shrink-0">
                  <i className={`${m.icon} text-red-500 text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm leading-snug">{m.title}</h3>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-4 flex-1">{m.desc}</p>
              <div className="bg-green-50 border border-green-200 rounded-md p-3">
                <p className="text-green-800 text-xs leading-relaxed">
                  <i className="ri-check-line text-green-500 mr-1"></i>
                  <strong>How to avoid it:</strong> {m.fix}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}